import { getAppImg } from '@shared/utils/image/url';
import { compressImage } from '@shared/utils/image';
import { parseCreationInfo } from '@shared/utils/image/parseCreationInfo';
import { historyWorksType, I_ImageHistory } from '@shared/typings/build/request/history';
import { tryParseJson } from '@shared/utils/json';

export const transformFlowHistoryItem = (item: I_ImageHistory.HistoryItem) => {
	const {
		creationInfo,
		isOptimizeImage,
		id,
		relatedImage,
		appId,
		appVersionId,
		image,
		state,
		shortId,
	} = item;

	let optimizeId = '';
	let compressId = '';
	const imageUrl = getAppImg(appId, appVersionId, image);
	const relatedImageUrl = relatedImage ? getAppImg(appId, appVersionId, relatedImage.image) : '';

	if (isOptimizeImage) {
		optimizeId = id;
		compressId = relatedImage ? relatedImage.id : id;
	} else {
		compressId = id;
		optimizeId = relatedImage ? relatedImage.id : '';
	}

	const compressImg = isOptimizeImage ? relatedImageUrl : imageUrl;
	const optimizeImg = isOptimizeImage ? imageUrl : relatedImageUrl;

	const newRelatedImage =
		isOptimizeImage && relatedImage?.id
			? { id, image, appId, appVersionId, state, shortId }
			: relatedImage;

	const paramParsed = tryParseJson(item.param) as
		| { videoSpecs?: I_ImageHistory.HistoryItem['videoSpecs'] }
		| undefined;
	const resolutionFromParam = paramParsed?.videoSpecs?.resolution;
	const resolutionRaw = item.resolution ?? item.videoSpecs?.resolution ?? resolutionFromParam;
	const normalizedResolution = Number(resolutionRaw);
	const resolution =
		normalizedResolution === 1 || normalizedResolution === 2 || normalizedResolution === 3
			? normalizedResolution
			: undefined;

	return {
		id: compressId,
		compressId, // 压缩Id
		compressImg, // 压缩Img
		optimizeId, // 精绘ID
		optimizeImg, // 精绘Img
		waterMarkId: '', // 水印图ID
		waterMarkImg: '', // 水印图Img
		...parseCreationInfo(creationInfo),
		appVersionId,
		isOptimizeImage,
		isPublish: item.state === 10,
		param: item.param,
		resolution,
		shortId: item.shortId,
		coverImage: item.cover ? getAppImg(appId, appVersionId, item.cover) : '',

		// 精绘, 之前transformData里加的数据
		relatedImage: newRelatedImage,

		// 本期大图预览需要用到的数据
		originSrc: compressImg,
		preloadImageSrc: compressImage(optimizeImg || imageUrl || '', { resize: '500' }),
		isWatermarkImage: item.isWatermarkImage,
		creationInfo: item.creationInfo,
		optimizeSrc: optimizeImg,
	} as historyWorksType;
};

export const transformFlowHistoryList = (list: I_ImageHistory.HistoryItem[]) => {
	return list.map((item) => transformFlowHistoryItem(item));
};
